import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import { observer, calculatorState as store, cookies as cookiesStore } from 'store';
import Container from 'components/UI/Container';
import CloseButton from 'components/UI/CloseButton';
import Title from 'components/UI/Title';
import Tag from 'components/UI/Tag';
import Button from 'components/UI/Button';
import { tagsManagement } from '../../utils';
import { useTrans } from 'utils/localisation';
import * as styles from './PreviewModal.module.scss';

function PreviewModal({ calculatorID, title }) {
  const t = useTrans(['common', 'calculator']);
  const { modal } = store.calculators[calculatorID];
  const { toggleModal, togglePreview } = store;
  const { tags, removeTagHandler } = tagsManagement(calculatorID, 'preview', t);

  const onHideModal = useCallback(() => togglePreview(calculatorID, false, true), [togglePreview]);
  const onShowModal = useCallback(() => {
    toggleModal(calculatorID, true);
  }, [toggleModal]);

  return ReactDOM.createPortal(
    <Container
      className={cn(
        styles.container,
        !cookiesStore.seen && styles[cookiesStore.theme],
        tags.length && modal.preview.show && !modal.show && styles.open,
      )}
      background="gray"
    >
      <CloseButton onClose={onHideModal} />
      <div className={styles.wrapper}>
        <Title className={styles.title} tag="p" size="h4">
          {title}
        </Title>
        <div className={styles.panel}>
          <div className={styles.tagsWrapper}>
            {tags.map(tag => (
              <Tag
                key={`${tag.key}-${tag.counter}`}
                theme="filtered"
                onClick={() => removeTagHandler(tag)}
              >
                {tag.name}
              </Tag>
            ))}
          </div>
          <Button className={styles.button} onClick={onShowModal}>
            {t('proceed')}
          </Button>
        </div>
      </div>
    </Container>,
    document.getElementById('___gatsby'),
  );
}

export default observer(PreviewModal);
